jQuery(window).scroll(function(){
  var sticky = jQuery('header'),
      scroll = jQuery(window).scrollTop();

  if (scroll >= 30) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});


  $(document).ready(function(){
  $('.reviews-slider').slick({
    slidesToShow: 3,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,
      responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
});